// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@ces/XDL/Utilities";
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

customerSelectorToolbarStyles.searchTextField = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            ${IconWrapper} {
                svg {
                    width: 14px;
                    height: 14px;
                }
            }
        `,
    },
    css: css`
        &&&&& {
            padding-right: 47px;
        }
    `,
};

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    variant: "tertiary",
    css: css`
        margin-left: 10px;
        min-height: 36px;
    `,
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;

        ${xScreen("lte", "md")} {
            margin-left: 16px;
        }
    `,
};
